import React,{useState} from 'react';
import {motion} from 'framer-motion';
import {FiCreditCard,FiSmartphone,FiGlobe,FiShield} from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import PaymentProcessor from './PaymentProcessor';
import SuccessModal from './SuccessModal';

const OfferRecap=({timeLeft,formatTime,onPaymentSuccess})=> {
  const [showPayment,setShowPayment]=useState(false);
  const [showSuccess,setShowSuccess]=useState(false);

  const handlePaymentSuccess=(customerData)=> {
    setShowPayment(false);
    setShowSuccess(true);
    onPaymentSuccess?.(customerData);
  };

  return (
    <section id="checkout" className="py-16 bg-gradient-to-br from-purple-600 to-orange-500 text-white">
      <div className="container mx-auto px-4">
        <motion.div 
          className="text-center mb-12"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Grab the Entire <span className="text-yellow-300">Diwali Stack</span>
            Before It's Gone 💵
          </h2>
          <div className="timer-glow bg-red-600 text-white px-6 py-3 rounded-xl inline-flex items-center space-x-2 mb-6">
            <span>⏰</span>
            <span className="font-bold text-xl">{formatTime(timeLeft)}</span>
            <span>Offer Ends When Timer Hits Zero</span>
          </div>
        </motion.div>

        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8">
            {/* Offer Stack */}
            <motion.div 
              className="bg-white/10 backdrop-blur-md p-8 rounded-3xl"
              initial={{opacity: 0, x: -50}}
              whileInView={{opacity: 1, x: 0}}
              transition={{duration: 0.6}}
              viewport={{once: true}}
            >
              <h3 className="text-2xl font-bold mb-6 text-center">What You Get Today</h3>
              
              <div className="space-y-4 mb-6">
                <div className="flex items-center justify-between p-4 bg-white/10 rounded-xl">
                  <span>📚 24 Ways eBook</span>
                  <span className="font-semibold">₹997</span>
                </div>
                <div className="flex items-center justify-between p-4 bg-white/10 rounded-xl">
                  <span>🎯 Diwali Workshop</span>
                  <span className="font-semibold">₹4,999</span>
                </div>
                <div className="flex items-center justify-between p-4 bg-white/10 rounded-xl">
                  <span>⚡ Automation Templates</span>
                  <span className="font-semibold">₹3,999</span>
                </div>
                <div className="flex items-center justify-between p-4 bg-white/10 rounded-xl">
                  <span>🛠️ Software Access</span>
                  <span className="font-semibold">₹5,999</span>
                </div>
                <div className="flex items-center justify-between p-4 bg-white/10 rounded-xl">
                  <span>📱 WhatsApp Tutorial</span>
                  <span className="font-semibold">₹6,999</span>
                </div>
                <div className="flex items-center justify-between p-4 bg-white/10 rounded-xl">
                  <span>🎯 Lead Gen Playbook</span>
                  <span className="font-semibold">₹3,499</span>
                </div>
              </div>

              <div className="border-t border-white/20 pt-4">
                <div className="flex items-center justify-between text-xl font-bold mb-2">
                  <span>Total Worth:</span>
                  <span>₹26,492</span>
                </div>
                <div className="flex items-center justify-between text-3xl font-bold text-yellow-300">
                  <span>Your Price Today:</span>
                  <span>₹97</span>
                </div>
                <p className="text-center text-sm mt-2 opacity-80">(One-Time Payment)</p>
              </div>
            </motion.div>

            {/* Payment Section */}
            <motion.div 
              className="bg-white/10 backdrop-blur-md p-8 rounded-3xl"
              initial={{opacity: 0, x: 50}}
              whileInView={{opacity: 1, x: 0}}
              transition={{duration: 0.6, delay: 0.2}}
              viewport={{once: true}}
            >
              {!showPayment ? (
                <div className="text-center">
                  <h3 className="text-2xl font-bold mb-6">Ready to Double Your Sales?</h3>
                  
                  <div className="bg-white/20 p-6 rounded-2xl mb-6">
                    <div className="text-4xl font-bold mb-2">₹97</div>
                    <p className="text-sm opacity-80">One-time payment for lifetime access</p>
                  </div>

                  <div className="space-y-3 mb-6 text-left">
                    <div className="flex items-center space-x-3">
                      <span className="text-green-300">✓</span>
                      <span>Instant access to all materials</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <span className="text-green-300">✓</span>
                      <span>All 5 bonuses included</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <span className="text-green-300">✓</span>
                      <span>7-day action guarantee</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <span className="text-green-300">✓</span>
                      <span>Secure payment via Razorpay</span>
                    </div>
                  </div>

                  <button 
                    onClick={()=> setShowPayment(true)}
                    className="glow-button text-white px-8 py-4 rounded-xl font-bold text-lg w-full"
                  >
                    💥 Proceed to Payment - ₹97
                  </button>

                  <div className="flex items-center justify-center space-x-2 text-sm mt-4 opacity-75">
                    <SafeIcon icon={FiShield} className="w-4 h-4" />
                    <span>100% Secure Payment</span>
                  </div>
                </div>
              ) : (
                <PaymentProcessor 
                  timeLeft={timeLeft}
                  onSuccess={handlePaymentSuccess}
                  onClose={()=> setShowPayment(false)}
                />
              )}
            </motion.div>
          </div>
        </div>
      </div>

      <SuccessModal 
        isOpen={showSuccess}
        onClose={()=> setShowSuccess(false)}
      />
    </section>
  );
};

export default OfferRecap;